<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-wrap xl:flex-nowrap flex-col sm:flex-row sm:justify-between sm:items-center gap-2">

        <div class="flex flex-col sm:flex-row gap-2">
            <!-- search -->
            <div class="relative">
                <input [(ngModel)]="search" (input)="onSearchInput()" type="text" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <!-- service areas selector -->
            <div>
                <select class="w-full sm:w-44" [(ngModel)]="selectedServiceArea" (change)="onServiceAreaChange()">
                    <option value="">Select Service Area</option>
                    <option *ngFor="let serviceArea of serviceAreas" value="{{serviceArea.id}}">{{ serviceArea.title |
                        titlecase }}</option>
                </select>
            </div>

            <!-- payment status selector -->
            <div>
                <select class="w-full sm:w-44" [(ngModel)]="selectedPaymentStatus"
                    (change)="onPaymentStatusChange()">
                    <option value="">All Payments</option>
                    <option value="unpaid">Unpaid</option>
                    <option value="paid">Paid</option>
                </select>
            </div>

            <!-- payment type selector -->
            <div>
                <select class="w-full sm:w-44" [(ngModel)]="selectedPaymentType"
                    (change)="onPaymentTypeChange()">
                    <option value="">All Payment Types</option>
                    <option value="none">None</option>
                    <option value="manual">Manual</option>
                    <option value="square">Square</option>
                    <option value="quickbook">Quickbook</option>
                </select>
            </div>

            <!-- Date picker -->
            <div>
                <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                    (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" />
                <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
            </div>

            <div *ngIf="filterdataList && filterdataList.length" class="flex items-center">
                <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (filterdataList !=
                    numberOfRecords? (numberOfRecords
                    -filterdataList.length) : 0) }} of {{totalResults }} entries
                </h1>
            </div>
        </div>

        <div class="relative inline-block text-left" (outsideClick)="closeFilterDropDown($event)" outside-click>
            <div>
                <button [appToolTip]="'Filters'" type="button" (click)="toggleDropdown($event)"
                    class="btn btn-secondary" id="menu-button" aria-expanded="true" aria-haspopup="true">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                    </svg>
                </button>
            </div>
            <div *ngIf="isDropdownOpen"
                class="absolute right-0 z-50 mt-2 w-72 origin-top-right rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                <div class="p-3 grid grid-cols-2 gap-2" role="none">
                    <hr class="sm:col-span-2 dark:border-white/10">
                    <div class="sm:col-span-2 mt-2" role="menuitem" tabindex="-1" id="menu-item-1">
                        <div class="p-1 grid grid-cols-1 gap-1">
                            <button type="button" class="btn btn-primary text-xs" (click)="downloadRawReport()">
                                Raw Report
                            </button>
                            <button type="button" class="btn btn-primary text-xs" (click)="tripDetailFile()">
                                Trip Report
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedTrips && selectedTrips.length" class="w-36 rounded-xl bg-gray-200 dark:bg-zinc-950 px-2 py-2">
        <dl class="flex items-center">
            <dd class="w-full truncate text-right">
                <div class="text-xs text-main-light flex-1 "> Selected Trips </div>
                <div class="text-sm font-bold text-main-secondary flex-1 truncate">{{selectedTrips.length}}</div>
            </dd>
        </dl>
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full table-auto">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #</th>
                                    <th *ngIf="filterdataList.length"
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <input type="checkbox"
                                            [checked]="selectedTrips.length && selectedTrips.length === filterdataList.length"
                                            (change)="onSelectAllTrips($event)" />
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Action</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Service Area</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Reference ID</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Funding Source</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Company</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Member</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Contact No.</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Pickup Time</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Dropoff Time</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Pickup Address</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Dropoff Address</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Miles</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Space Type</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        LOS</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Appointment Type</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Onway</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Arrived</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Inprogress</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Completed</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Created At</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Billing Status</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Payment Status</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Payment Type</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        General Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let trip of filterdataList | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i = index;"
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td *ngIf="trips.length"
                                        class="relative px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <!-- Selected row marker, only show when row is selected. -->
                                        <div class="absolute inset-y-0 left-0 w-0.5 bg-main-primary"
                                            [ngClass]="{'hidden': !trip.isSelected}">
                                        </div>
                                        <input (click)="onSelectTrip(trip)" type="checkbox"
                                            [(ngModel)]="trip.isSelected" />
                                    </td>
                                    <!-- actions -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex">
                                            <button [appToolTip]="'Detail'" (click)="opendetailModal(trip)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                </svg>
                                            </button>
                                            <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                                            <button [appToolTip]="'Notes'" (click)="openNotesModal(trip)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                    viewBox="0 0 24 24" class="h-5 w-5">
                                                    <path fill="currentColor"
                                                        d="M7.154 13.539q.31 0 .54-.23q.229-.23.229-.54t-.23-.54t-.54-.229t-.538.23t-.23.54q0 .309.23.539t.539.23m0-2.77q.31 0 .54-.23q.229-.23.229-.539t-.23-.54t-.54-.23t-.538.23t-.23.54t.23.54t.539.23m0-2.77q.31 0 .54-.23t.229-.54t-.23-.539t-.54-.23t-.538.23t-.23.54t.23.54t.539.229m3.077 5.27H14.5v-1h-4.27zm0-2.77H17.5v-1h-7.27zm0-2.77H17.5v-1h-7.27zM3 20.078V4.616q0-.691.463-1.153T4.615 3h14.77q.69 0 1.152.463T21 4.616v10.769q0 .69-.463 1.153T19.385 17H6.077zM5.65 16h13.735q.23 0 .423-.192t.192-.423V4.615q0-.23-.192-.423T19.385 4H4.615q-.23 0-.423.192T4 4.615v13.03zM4 16V4z" />
                                                </svg>
                                            </button>
                                            <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                                            <div class="inline-flex relative">
                                                <a [appToolTip]="'More Actions'" *ngIf="!trip.isSelected"
                                                    href="javascript:void(0)" (click)="showActionButtons(i)"
                                                    class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                                    </svg>
                                                </a>
                                                <div (outsideClick)="closeActionMenu($event)" outside-click
                                                    *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                                                    class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                                                    role="menu" aria-orientation="vertical" aria-labelledby="menu-button"
                                                    tabindex="-1">
                                                    <app-trip-action-dropdown
                                                        class="divide-y divide-zinc-950/10 dark:divide-white/10"
                                                        [trip]="trip" [source]="'billing'"
                                                        (detail)="opendetailModal($event)"
                                                        (notes)="openNotesModal($event)"
                                                        (tripTrails)="openTripTrails($event)"
                                                        [canPay]="trip.payment?.status !== 'paid'"
                                                        (pay)="openPayModal($event)"></app-trip-action-dropdown>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <!-- Service Areas -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preServiceAreas && preServiceAreas[trip.serviceArea]">
                                            {{(preServiceAreas[trip.serviceArea].title | titlecase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <!-- Reference -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>
                                            {{ trip.reference || 'N/A' }}{{trip.suffix ? '-' + trip.suffix : '' }}
                                        </span>
                                    </td>
                                    <!-- Funding Source -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preFundingSource && trip.fundingsource">
                                            {{(preFundingSource[trip.fundingsource]?.title | titlecase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <!-- Company -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preCompanies && preCompanies[trip.company]; else elseBlock">
                                            {{ (preCompanies[trip.company].name | titlecase) || 'N/A' }}
                                        </span>
                                    </td>
                                    <!-- member -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>
                                            {{(trip?.member?.displayName | titlecase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <!-- phoneNumber -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap"
                                        phoneNumberFormat [phoneNumber]="trip?.member?.contactNumber">
                                        {{ trip?.member?.contactNumber || 'N/A'}}
                                    </td>
                                    <!-- pickuptime -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>{{(trip?.pickup?.time | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</span>
                                    </td>
                                    <!-- DO time -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>{{trip?.destination?.time | date: 'MM/DD/YYYY HHmm'}}</span>
                                    </td>
                                    <!-- pickup address -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{trip?.pickup?.address?.name || 'N/A'}}</td>
                                    <!-- destination address -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{trip?.destination?.address?.name || 'N/A'}}</td>
                                    <!-- miles -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{ trip.miles ? (trip.miles | number:'1.0-2') + ' mi' : 'N/A' }}
                                    </td>
                                    <!-- spaceType -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType];else elseBlock">
                                            {{(preSpacetypes[trip.spaceType].title | uppercase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <!-- LOS -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span
                                            *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService];else elseBlock">
                                            {{(preLevelOfService[trip.levelOfService].title | uppercase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <!-- appointmentType -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span
                                            *ngIf="preAppointmentType && preAppointmentType[trip.appointmentType]; else elseBlock">
                                            {{(preAppointmentType[trip.appointmentType].title | titlecase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>{{ (trip.onway?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>{{ (trip.arrived?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>{{ (trip.inProgress?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>{{ (trip.completed?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                    </td>
                                    <!-- createdAt -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{(trip.createdAt | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div [ngClass]="trip.status === 'cancelled' ? 'badge-danger' : 'badge-success'">
                                            {{(trip.status | titlecase) || 'N/A'}}
                                        </div>
                                    </td>
                                    <!-- billingStatus -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                        <div
                                            [ngClass]="{'badge-danger': trip.billingStatus === 'rejected', 'badge-yellow' : trip.billingStatus === 'resubmit', 'badge-success' : trip.billingStatus === 'accepted', 'badge-primary' : trip.billingStatus === 'pending'}">
                                            {{ (trip.billingStatus | titlecase) || 'N/A'}}
                                        </div>
                                    </td>
                                    <!-- payment status -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div
                                            [ngClass]="{'badge-success': trip.payment?.status === 'paid', 'badge-primary': trip.payment?.status === 'unpaid'}">
                                            {{ (trip.payment?.status | titlecase) || 'N/A' }}
                                        </div>
                                    </td>
                                    <!-- payment type -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{ (trip.payment?.relationType !== 'none' && (trip.payment?.relationType | titlecase)) || 'N/A' }}
                                    </td>
                                    <!-- generalNotes -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                        <div class="w-72 line-clamp-2">
                                            {{(trip.generalNotes) || 'N/A'}}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ng-template #elseBlock>N/A</ng-template>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>

    </div>

</section>

<app-trip-detail-modal *ngIf="tripId" [source]="'billing'" [tripId]="tripId"
    (closeModal)="tripId = null"></app-trip-detail-modal>
<app-notes-modal *ngIf="memberNotesObj" [notes]="memberNotesObj" (closeModal)="memberNotesObj = null"></app-notes-modal>
<app-trips-trails-modal *ngIf="tripTrailId" [tripId]="tripTrailId"
    (closeModal)="tripTrailId = null"></app-trips-trails-modal>
<app-manual-payment-modal *ngIf="payModalObj" [trip]="payModalObj" [relation]="payRelation"
    (closeModal)="onClosePayModal($event)"></app-manual-payment-modal>
